// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"92d524c3","453":"085708ea","455":"8fa0208f"}[chunkId] + ".chunk.js";
};